<template>
  <div class="section-scene mainList">
      <div class="mainList-bg-enter"></div>
      <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
      <div class="first-page">
          <div class="background">
              <img :src="static_img_url + 'pic/index/bg-4.jpg'">
          </div>
          <div class="rightSum summary rightSum-enter">
              <div class="tle">
                  医疗行业的未来发展方向，不取决于数据预测<br>
                  而是来自于正在发生的科技创新。
              </div>
              <div class="rightSum-content">
                <p>未来医疗100强主榜是由动脉网、蛋壳研究院推出的国内第一个针对非上市企业的创新医疗领域榜单，旨在遴选真正代表未来医疗的中国创新医疗企业，发现我国未来医疗产业的核心力量。</p>
                <p>2020年未来医疗100强主榜包含中国医疗服务榜、中国数字医疗榜、中国创新器械榜、中国创新医药榜、中国医疗商业服务榜、海外创新企业榜六张榜单。</p>
              </div>
              <img :src="static_img_url + 'pic/index/logo1.png'" class="logo1">
              <img :src="static_img_url + 'pic/index/main_rank.png'" class="main-rank">
          </div>
          <!-- <div class="light"></div> -->
      </div>
      <div class="swiper-container second second-enter second-01 second-02">
          <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="one">
                    <div class="swiper-rows">
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/1-1.png'" class="img-big">
                      </div>
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/1.png'" class="img-small">
                      </div>
                    </div>
                    <div class="swiper-rows">
                      <div class="rows-item rows-tle">
                        <p class="gold-tle">中国医疗服务榜</p>
                      </div>
                      <div class="rows-item rows-desc">
                        <p>本榜单主要面向医疗服务领域非上市企业，主要覆盖为患者直接提供医疗服务的线上平台及线下机构。</p>
                        <p>包括但不限于非公医疗领域的综合/专科/单体/连锁医院、诊所，医生集团、互联网医院等相关领域企业。</p>
                      </div>
                    </div>
                </div>
                <div class="two split-line">
                  <div class="swiper-rows">
                    <div class="rows-item">
                      <img :src="static_img_url + 'pic/mainList/2.png'" class="img-small">
                    </div>
                    <div class="rows-item swiper-rows">
                      <div class="rows-tle">
                        <p class="gold-tle">中国数字医疗榜</p>
                      </div>
                    </div>
                  </div>
                    <div class="swiper-rows">
                      <div class="rows-item rows-desc">
                        <p>本榜单主要面向科技医疗领域非上市企业，主要覆盖以互联网、人工智能、物联网、5G等数字技术创新，赋能医疗过程数字化升级，医院信息系统建设，医疗设备数字化升级，医疗企业业务流程改进及产品服务提升的企业，</p>
                        <p>包括但不限于数字疗法（糖尿病/心理健康/睡眠健康等）、医疗信息化（远程医疗/医疗SaaS/电子病历/医保信息化等）、医疗AI（预防管理/辅助诊断/辅助治疗/临床工作流/康复/新药研发等）、医疗物联网（包含应用层/平台层/网络层/感知层的各类应用）</p>
                      </div>
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/2-1.png'" class="img-big">
                      </div>
                    </div>
                </div>
                <div class="three split-line">
                  <div class="swiper-rows">
                    <div class="rows-item">
                      <img :src="static_img_url + 'pic/mainList/3.png'" class="img-small">
                    </div>
                    <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/3-1.png'" class="img-big">
                      </div>
                  </div>
                  <div class="swiper-rows">
                    <div class="rows-item swiper-rows">
                      <div class="rows-tle">
                        <p class="gold-tle">中国创新器械榜</p>
                      </div>
                    </div>
                    <div class="rows-item rows-desc">
                      <p>本榜单主要面向医疗器械领域非上市企业，主要覆盖以家用/院外器械、院内使用器械为主的医疗器械产业链上下游企业，</p>
                      <p>包括但不限于高值耗材（心血管/骨科/眼科/口腔等）、低值耗材、体外诊断（生化诊断试剂/免疫诊断试剂/分子诊断试剂/poct/微生物试剂等）、设备（病理/影像/监护/急救与治疗/康复等）。</p>
                    </div>
                  </div>
                </div>
                <div class="four split-line">
                  <div class="swiper-rows">
                    <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/4-1.png'" class="img-big">
                      </div>
                    <div class="rows-item">
                      <img :src="static_img_url + 'pic/mainList/4.png'" class="img-small">
                    </div>
                  </div>
                  <div class="swiper-rows">
                    <div class="rows-item swiper-rows">
                      <div class="rows-tle">
                        <p class="gold-tle">中国创新医药榜</p>
                      </div>
                    </div>
                    <div class="rows-item rows-desc">
                      <p>本榜单主要面向创新医药领域非上市企业，主要覆盖以创新药及创新疗法为代表的医药产业链上下游企业，</p>
                      <p>包括但不限于生物药、化药、中药、生物疗法、二类新药、CRO/CMO/CDMO等企业。</p>
                    </div>
                  </div>
                </div>
                <div class="two split-line">
                  <div class="swiper-rows">
                    <div class="rows-item">
                      <img :src="static_img_url + 'pic/mainList/5.png'" class="img-small">
                    </div>
                    <div class="rows-item swiper-rows">
                      <div class="rows-tle">
                        <p class="gold-tle">中国医疗商业服务榜</p>
                      </div>
                    </div>
                  </div>
                    <div class="swiper-rows">
                      <div class="rows-item rows-desc">
                        <p>本榜单主要面向医疗产业服务领域非上市企业，主要覆盖医疗产业中创新渠道/流通/支付环节服务B端的企业，</p>
                        <p>包括但不限于渠道流通、医疗保险（医保控费服务/疾病商业保险）、CSO等企业。</p>
                      </div>
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/5-1.png'" class="img-big">
                      </div>
                    </div>
                </div>
                <div class="one split-line">
                    <div class="swiper-rows">
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/6-1.png'" class="img-big">
                      </div>
                      <div class="rows-item">
                        <img :src="static_img_url + 'pic/mainList/6.png'" class="img-small">
                      </div>
                    </div>
                    <div class="swiper-rows">
                      <div class="rows-item rows-tle">
                        <p class="gold-tle">海外创新企业榜</p>
                      </div>
                      <div class="rows-item rows-desc">
                        <p>本榜单主要面向海外医疗健康创新创业企业</p>
                        <p>按照企业的累计融资金额由高到低排名，旨在发现全球产业变化趋势，为中国医疗健康产业的发展提供重要参考。</p>
                      </div>
                    </div>
                </div>
                <div class="bot-rules">
                    <div class="rules">
                        <p class="tle">参选条件</p>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/A.png'">
                            <p>医疗领域非上市企业；</p>
                        </div>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/B.png'">
                            <p>具备持续运营的能力；</p>
                        </div>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/C.png'">
                            <p>拥有核心技术/产品服务/商业模式方面的创新；</p>
                        </div>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/D.png'">
                            <p>至少获得天使轮融资；</p>
                        </div>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/E.png'">
                            <p>主要运营地在中国大陆地区；</p>
                        </div>
                        <div class="item">
                            <img :src="static_img_url + 'pic/mainList/F.png'">
                            <p>截止至评选日期前尚在运营。</p>
                        </div>
                        <a href="http://vcbeat-vb100.mikecrm.com/cbPkDrl" target="_block" class="btns">报名参选</a>
                    </div>
                </div>
                <div class="six"></div>
              </div>
          </div>
      </div>
      <div class="mainList-bg-leave"></div>
  </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'

export default {
  mixins:[anima_mixins],
  data() {
    return {
      static_img_url: process.env.VUE_APP_CDN,
      defaultPage: 2,
      
      page: 1,
      lock: true, // 锁定滚动 true: 可以滑动， false: 禁止滑动
      nScrollTop: 0, //滚动到的当前位置
      nScrollHight: 0, //滚动距离总长(注意不是滚动条的长度)
      nDivHight: 0,
      innerHeight: 0, //屏幕宽度

      oneJump: true
    };
  },
  watch:{
    activePage(n,o){ // 监听进入
      this.innerHeight = window.innerHeight == 0 ?'': window.innerHeight
      if( this.activePage == this.defaultPage && this.nDivHight == 0){
        this.initMousewheel()
      }
    },
    innerHeight(){
      this.nDivHight = $(".second").height();
    }
  },
  methods: {
    async divEnterAnime(){ // 第一屏到第二屏进入动画
      await timeoutSync(() => {
        $('.second').removeClass('second-01')
      },1)
      await timeoutSync(() => {
        $('.second').removeClass('second-02')
        $('.rightSum').addClass('summary-01')
        $('.rightSum').addClass('summary-02')
        $('.background').addClass('bg-01')
      },600)
      $('.swiper-wrapper').addClass('joinUp')
      $('.second').scrollTop(30);
      this.page = 2
      this.lock = true
      this.$emit('setLock', true)
    },
    async divLeaveAnime(){ // 第二屏到第一屏离开动画
      await timeoutSync(() => {
        $('.second').addClass('second-02')
        $('.rightSum').removeClass('summary-02')
        $('.swiper-wrapper').removeClass('joinUp')
        $('.background').removeClass('bg-01')
      },1)
      await timeoutSync(() => {
        $('.second').addClass('second-01')
        $('.rightSum').removeClass('summary-01')
      },600)
      this.page = 1
      this.lock = true
      this.$emit('setLock', true)
    },
    initMousewheel(){ // 监听鼠标滚轮，将来可能会废除
      let _that = this
      this.nDivHight = $(".second").height();
      $(".second").scroll(async function(){
        _that.nScrollHight = $(this)[0].scrollHeight;
        _that.nScrollTop = $(this)[0].scrollTop;
        if(_that.nScrollTop + _that.nDivHight >= _that.nScrollHight - 10){
          // console.log("滚动条到底部了");
          _that.lock = false
          _that.$emit('setLock', false)
          if( _that.oneJump ){
            _that.oneJump = false
            _that.$emit('setNextPage', _that.nextPage + 1)
          }
        }
        if(_that.nScrollTop <= 0 && _that.page == 2){
          // console.log("滚动条到顶了");
          _that.lock = false
          _that.$emit('setLock', false)
          _that.divLeaveAnime()
        }
      })
      $('.mainList').mousewheel(async function (event, delta) {
        if(!_that.lock){
          return
        }
        if (delta == 1) { // 向上滚
            if(_that.page == 1){
              _that.lock = false
              _that.$emit('setLock', false)
              if( _that.oneJump ){
                _that.oneJump = false
                // console.log('跳转')
                _that.$emit('setNextPage',_that.nextPage - 1)
              }
            }
            if( _that.page == 2 ){
              _that.nScrollTop = _that.nScrollTop - 80 <= 0 ? 0 :  _that.nScrollTop - 80
              $('.second').scrollTop(_that.nScrollTop);
            }
          } else if (delta == -1) { // 向下滚
            if(_that.page == 1){
              _that.lock = false
              _that.$emit('setLock', false)
              _that.divEnterAnime()
            }
            if(_that.page == 2 ){
              if(  _that.nScrollTop + _that.nDivHight <= _that.nScrollHight ){
                _that.nScrollTop = _that.nScrollTop + 80
              }
              $('.second').scrollTop(_that.nScrollTop);
            }
          }
        event.stopPropagation();
      });
      $('.second').mousewheel(function (event, delta) { // 阻止操作父级滚动
          event.stopPropagation();
      });
    },
    //进入时
    async downEnter (){
      // console.log('mainList:下 我进来了')
      await timeoutSync(() => {
        $('.mainList-bg-enter').addClass('mainList-bg-enter-end')
      },100)
      await timeoutSync( () => {
        $('.rightSum').removeClass('rightSum-enter')
        $('.second').removeClass('second-enter')
      },200)
      this.$emit('setLock', true)
      this.lock = true
      this.oneJump = true
    },
    async upEnter(){
      // console.log('mainList:上 我进来了')
      $('.second').scrollTop(this.nScrollTop - 60)
      await timeoutSync(() => {
        $('.mainList-bg-leave').removeClass('down-leave')
      },100)
      await timeoutSync(() => {
        this.$emit('setLock', true)
        this.lock = true
        this.oneJump = true
      },600)
    },
    /* 
    *  离开时
    */
    async downLeave(){
      // console.log('mainList:下 我离开了')
      this.$emit('setLock',false)
      $('.mainList-bg-leave').addClass('down-leave')
      await timeoutSync( () => {
        this.$emit('setActivePage',this.nextPage)
      }, 600)
    },
    async upLeave(){
      // console.log('mainList:上 我离开了')
      this.$emit('setLock',false)
      $('.mainList-bg-enter').removeClass('mainList-bg-enter-end')
      $('.second').addClass('second-enter')
      $('.rightSum').addClass('rightSum-enter')
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      },300)
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';
@import "../../../node_modules/swiper/dist/css/swiper.css";

.background
  img 
    top 0
    right 0
.bg-01
  img
    width: px2vw(967) !important
    height: px2vh(839) !important
.mainList
    .first-page
      .summary
          width px2vw(1360)
          height px2vh(440)
          background #232323
          position absolute
          padding px2vh(80) px2vw(80)
          right 0
          bottom 0
          color #ffffff
          transition all .6s
          .tle,.rightSum-content
            position absolute
            transition all .6s
            transform scale(1)
            opacity 1
          .tle
              font-size: px2vh(24);
              line-height:px2vh(40)
          .rightSum-content
              top px2vh(198)
              width px2vw(700)
              font-size: px2vh(16)
              line-height:px2vh(28)
              p:nth-child(2)
                  margin-top px2vh(45)
          .logo1
              position absolute
              right px2vw(80)
              top px2vh(80)
              width px2vw(400)
          .main-rank
              position absolute
              right px2vw(80)
              top px2vh(170)
              width px2vw(125)
      .summary-02
        width px2vw(800)
      .summary-01
        .tle,.rightSum-content
          transform scale(.5)
          opacity 0
      .rightSum-enter
        transform: translateX(100%);
    .second
        position absolute
        left 0
        top 0
        background #1E1E1E
        width px2vw(1120)
        height 100%
        transition all .6s
        font-size:16px;
        line-height:24px;
        color #ffffff
        overflow-y auto
        .swiper-wrapper
            // min-width 1120px
            transition all .6s
            transform: translateY(100%)
            &.joinUp
              transform: translateY(0)
        .split-line
          position relative
          &:after
            content: ''
            position absolute
            left px2vw(80)
            top: -120px
            width:120px;
            height:20px;
            background:linear-gradient(90deg,rgba(213,161,77,1),rgba(255,214,149,1));
        .one,.two,.three,.four
          padding 0 px2vw(80)
          .swiper-rows
            display flex
            flex-direction row
            position relative
            .rows-item
              display flex
              flex-direction column
              width px2vw(465)
              // min-width px2vw(465)
              .img-big
                width 100%
              .img-small
                width px2vw(200)
                // min-width 140px
            .rows-item + .rows-item
              margin-left px2vw(30)
            .rows-tle
              font-size 36px
            .rows-tle
              // width 100%
              .gold-tle
                font-size: 36px !important
                line-height: 40px;
                @media screen and (max-width: 1366px)
                  font-size: 26px !important
            .rows-desc
              font-size: 16px;
              color #FFFFFF
              // width 100%
              line-height:26px;
              @media screen and (max-width: 1366px)
                font-size: 14px
                line-height:24px;
              p + p
                margin-top px2vw(30)
          .swiper-rows + .swiper-rows
            margin-top px2vw(30)
        .one
          margin-top 260px
          >.swiper-rows
            .rows-item
              .img-small
                margin-top auto
            .rows-tle
              text-align right
        .two
          margin-top 285px
          .swiper-rows
            .rows-item
              .img-small
                margin-left auto
            .rows-tle
              margin-top auto
            .rows-desc
              text-align right 
        .three
          margin-top 285px
          .swiper-rows
            .rows-item
              .img-small
                margin-top auto
                margin-left auto
            .rows-tle
              text-align right
        .four
          margin-top 285px
          .swiper-rows
            .rows-item
              .img-small
                margin-top auto
            .rows-tle
              text-align right
        .bot-rules
            display flex
            justify-content center
            padding 0 px2vw(80)
            .tle
                font-size 22px
                margin-top px2vh(120)
            .rules
                width 100%
                position relative
                .item 
                    margin-top 25px
                    display flex
                    flex-direction row
                    img 
                        width:38px;
                        margin-right 10px
                    p
                      line-height 16px
                      margin-top auto
                .btns
                    cursor pointer
                    position absolute
                    right 0
                    bottom 0
                    width: px2vw(240)
                    height: px2vh(60)
                    background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
                    border-radius:30px;
                    text-align center
                    color #000000
                    line-height px2vh(60)
        .six
            height 175px
    .second-enter
      transform translateX(100vw)
    .second-01
        top px2vh(860)
    .second-02
        width px2vw(560)
        overflow hidden
  .mainList-bg-enter
    position absolute
    left 0
    bottom 0
    z-index 20
    width 100vw
    height 100vw
    background #1e1e1e
    transition all .6s
  .mainList-bg-enter-end
    width: 0;
    height: 0
  .mainList-bg-leave
    position absolute
    right 0
    bottom 0
    width 0
    height 0
    background #232323
    transition all .6s
    z-index 30
    &.down-leave
      width 100vw
      height 100vh
      background #000000
</style>